require('./bootstrap');
require('select2');
// require('./cards-until-nav-change');
require('./results');
require('./momentresults');
require('./adminreport');
require ('./map');

// Alpine is provided by Livewire 3 (it bundles and starts its own copy).
// Do NOT import or start Alpine here — a second instance breaks every
// Alpine directive on the page (x-data/x-init/@entangle), which is what
// stopped the dashboard's lazy-loading Livewire components from rendering.

